
function kbBreadcrumb(title){
    var home = '<a href="/home" class="breadcrumb-item"><i class="icon-home2 mr-2"></i>Home</a>';
    var root = '<a href="/explore/docs" class="breadcrumb-item"><i class="icon-library2 mr-2"></i>Knowledge Base</a>';
    var doc  = typeof title == 'undefined' ? '' : '<a class="breadcrumb-item">'+title+'</a>';
    $('.breadcrumb').html(
        home
      + root
      + doc
    );

}
var KbTree = function() {

    var _kbTree = function() {
        if (!$().fancytree) {
            console.warn('Warning - fancytree_all.min.js is not loaded.');
            return;
        }
        $(".tree-docs").fancytree({
            extensions: ['filter'],
            source: {
                url: '/explore/docs/tree'
            },
            loadError: function(event, data) {
                Debug.log(event.type, data);
            },
            init: function(event, data){
                // 
            },
            checkbox: false,
            activeVisible: true,
            selectMode: 2,
            focusOnSelect: true,
            postProcess: function(event, data) {
                var tree = $.ui.fancytree.getTree();
                if(data.response[0]['data-json'].root == 1){
                    var node = tree.rootNode.children[0];
                    node.setSelected();
                }
            }, 
            focus: function(event, data){
                if(false == data.node.folder){
                    $('#doc-load-spinner').removeClass('d-none');
                    Do.Ajax("/explore/docs/fetch",{
                        _method: 'GET',
                        data: {
                            id: data.node.key,
                            meta: data.node.data["data-json"],
                        },
                    });
                    if(data.node.data['data-json'].root == 1){
                        history.pushState(null, 'Promana People | Knowledge Base | Home', '/explore/docs');
                        kbBreadcrumb();
                    }else{
                        history.pushState(
                            null, 
                            'Promana People | Knowledge Base | '+data.node.title, 
                            '/explore/docs/view/'+data.node.key);
                            kbBreadcrumb(data.node.title)
                    }
                }
            },
        });

    };

    return {
        init: function() {
            _kbTree();
        }
    }
}();

function paintDocument(response){
    $('#doc-load-spinner').addClass('d-none');
    $('#doc-content').html(response.partial);
}

document.addEventListener("DOMContentLoaded", function() {

    KbTree.init();
    $('load-doc').on('click',function(){
        var id = $(this).data('id');
        var $myTree = $(".tree-docs").fancytree();
        var tree = $myTree.fancytree("getTree");
        var node = tree.getNodeByKey(key);
        node.trigger('click');
    });
    $('#nda_consent').on('show.bs.modal',function(e){
        $('#nda-consent-submit').on('click',function(){
            if($('#nda-consent-text').val() == 'I AGREE'){
                Do.Ajax("/explore/docs/nda",{});
                $('#nda_consent').modal('hide');
            }else{
                Do.Notify({
                    'title': null,
                    'content':'Type "I AGREE" in the text field',
                    'class':'info',
                    'delay':2000
                });
            }
        });
    });
});

